import { doc, getDoc, setDoc, increment } from "firebase/firestore";
import { db } from "../firebase/config";

const SUMMARY_DOC = "otApproval";

/**
 * Get the OT approval summary for a company.
 * Returns { pending, approved, autoApproved, rejected, updatedAt } or defaults.
 */
export const getOtApprovalSummary = async (companyId) => {
  const ref = doc(db, "companies", companyId, "summaries", SUMMARY_DOC);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    return snap.data();
  }

  return { pending: 0, approved: 0, autoApproved: 0, rejected: 0 };
};

/**
 * Update OT approval summary counters when a status changes.
 * Uses Firestore increment() for atomic counter updates.
 *
 * @param {string} companyId
 * @param {string|null} oldStatus - Previous otApproval status (null if new record or had no otApproval)
 * @param {string|null} newStatus - New otApproval status (null if otApproval removed, e.g. OT edited to 0)
 */
export const updateOtApprovalSummary = async (companyId, oldStatus, newStatus) => {
  // No change
  if (oldStatus === newStatus) return;

  const ref = doc(db, "companies", companyId, "summaries", SUMMARY_DOC);

  const statusToField = {
    pending: "pending",
    approved: "approved",
    "auto-approved": "autoApproved",
    rejected: "rejected",
  };

  const updates = { updatedAt: new Date() };

  // Decrement old status counter
  if (oldStatus && statusToField[oldStatus]) {
    updates[statusToField[oldStatus]] = increment(-1);
  }

  // Increment new status counter
  if (newStatus && statusToField[newStatus]) {
    updates[statusToField[newStatus]] = increment(1);
  }

  await setDoc(ref, updates, { merge: true });
};
